<template>
    <div class="energyLabel">
        <div class="picto">
            <div class="d-flex align-items-center">
                <button
                    v-if="energyLabel.labelImage"
                    class="border-0 bg-transparent"
                    data-bs-target="#modal-energyLabel"
                    data-bs-toggle="modal"
                    data-oevent-category="fiche_detail_equipement_conso"
                    :data-oevent-label="'indice_' + energyLabel.efficiencyClass"
                    :data-oevent-action="energyLabel.sheetUrl"
                    title="Ouvrir la fiche d'information énergétique du produit"
                >
                    <img
                        class="align-self-center my-1"
                        :alt="'terminal de classe énergétique ' + energyLabel.efficiencyClass"
                        :src="energyLabel.efficiencyClassImage"
                    >
                </button>

                <a
                    v-else-if="energyLabel.sheetUrl"
                    :href="sheetHref"
                    target="_blank"
                    data-oevent-category="fiche_detail_equipement_conso"
                    :data-oevent-label="'indice_' + energyLabel.efficiencyClass"
                    :data-oevent-action="energyLabel.sheetUrl"
                    title="Ouvrir la fiche d'information énergétique du produit"
                >
                    <img
                        class="align-self-center my-1"
                        :alt="'terminal de classe énergétique ' + energyLabel.efficiencyClass"
                        :src="energyLabel.efficiencyClassImage"
                    >
                </a>

                <a
                    v-if="energyLabel.labelImage || energyLabel.sheetUrl"
                    :href="sheetHref"
                    target="_blank"
                    class="ps-1"
                >
                    <strong v-html="energyLabel.popinLinkLabel" />
                </a>
            </div>
        </div>
        <ob1-popin-modal2 :id="'modal-energyLabel'" :aria-labelledby="'modal-label-energyLabel'">
            <p :id="'modal-label-energyLabel'" class="h4" v-html="energyLabel.popinTitle" />
            <img
                alt=""
                class="w-50"
                :src="energyLabel.labelImage"
            >
            <ob1-liens
                v-if="energyLabel.sheetUrl"
                :with-arrow="true"
                :is-large="true"
                :text="energyLabel.sheetLinkLabel"
                :href="sheetHref"
                :target="'_blank'"
            />
        </ob1-popin-modal2>
    </div>
</template>

<script>
export default {
    name: "EnergyLabel",
    props: {
        energyLabel: {
            type: Object,
            required: true
        }
    },
    computed: {
        sheetHref: function() {
            return this.energyLabel.sheetUrl + "?webview_action=pdf";
        }
    }
};
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.picto {
    width: px-to-rem(250);
}
</style>
